<template>
  <div>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.headerFooter.header.logoSection.title') }}</div>
      <div class="row">
        <div class="every">
          <span>{{ $t('admin.headerFooter.header.logoSection.preview') }}</span>
          <div class="content">
            <div class="preview" :style="{ background: form.logoBackground}">
              <img :src="form.logoUrl" alt="" />
              <div class="user">
                <img src="" alt="" />
                <span :style="{color: form.logoFont}">{{ $t('admin.headerFooter.header.logoSection.login') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="every must" style="width: 26%">
          <span>{{ $t('admin.headerFooter.header.logoSection.image.label') }}</span>
          <div class="content">
            <Upload 
              :fileUrl="form.logoUrl" 
              @uploadData="uploadData" 
              :desc="$t('admin.headerFooter.header.logoSection.image.description')" 
              :accept="['png']"
            ></Upload>
          </div>
        </div>
        <div class="every" style="width: 40%">
          <span>{{ $t('admin.headerFooter.header.logoSection.background.label') }}</span>
          <div class="content">
            <a-radio-group class="radioGroup" v-model="logoBackgroundHas" @change="changeColor('logoBackground')">
              <a-radio :value="false">{{ $t('admin.headerFooter.header.logoSection.background.options.none') }}</a-radio>
              <a-radio :value="true">{{ $t('admin.headerFooter.header.logoSection.background.options.color') }}</a-radio>
            </a-radio-group>
            <div class="colorSelect" @click="colorSelect('logoBackground')" v-if="logoBackgroundHas">
              <div :style="{ background: form.logoBackground }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
            <div class="colorSelectPicker" v-show="showPicker" @click="showPicker = false">
              <div id="picker" @click.stop></div>
            </div>
          </div>
        </div>
        <div class="every" style="width: 26%">
          <span>{{ $t('admin.headerFooter.header.logoSection.fontColor.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('logoFont')">
              <span @click.stop="resetColor('logoFont')">{{ $t('admin.headerFooter.header.logoSection.fontColor.reset') }}</span>
              <div :style="{ background: form.logoFont }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="title">{{ $t('admin.headerFooter.header.navigation.title') }}</div>
      <div class="row">
        <div class="every">
          <span>{{ $t('admin.headerFooter.header.navigation.preview') }}</span>
          <div class="content">
            <div class="preview previewNavigation" :style="{ background: form.navigateBackground}">
              <div class="tag" v-for="(item, index) of typeList" :key="index" :class="{tagSelect: index === 0}">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="every" style="width: 40%">
          <span>{{ $t('admin.headerFooter.header.navigation.background.label') }}</span>
          <div class="content">
            <a-radio-group class="radioGroup" v-model="navigateBackgroundHas" @change="changeColor('navigateBackground')">
              <a-radio :value="false">{{ $t('admin.headerFooter.header.navigation.background.options.none') }}</a-radio>
              <a-radio :value="true">{{ $t('admin.headerFooter.header.navigation.background.options.color') }}</a-radio>
            </a-radio-group>
            <div class="colorSelect" @click="colorSelect('navigateBackground')" v-if="navigateBackgroundHas">
              <div :style="{ background: form.navigateBackground }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'
import iro from '@jaames/iro'
import { columnList } from '@/api/admin'

export default {
  name: 'Header',
  components: {
    Upload
  },
  data() {
    return {
      form: {
        logoBackground: '',
        navigateBackground: '',
        logoUrl: ''
      },
      typeList: [],
      showPicker: false,
      colorKey: '',
      logoBackgroundHas: false,
      navigateBackgroundHas: false
      // Your data here
    }
  },
  watch: {
    'form.logoBackground': {
      handler(val) {
        console.log(val)
        this.logoBackgroundHas = !!val
      },
      immediate: true
    },
    'form.navigateBackground': {
      handler(val) {
        this.navigateBackgroundHas = !!val
      },
      immediate: true
    }
  },
  methods: {
    // Your methods here
    uploadData(data) {
      console.log(data)
      this.form.logoUrl = data.length ? data[0].url : ''
      this.$forceUpdate()
    },
    colorSelect(key) {
      this.colorKey = key
      this.showPicker = !this.showPicker
    },
    resetColor(key) {
      this.form[key] = ''
      this.$forceUpdate()
    },
    changeColor(key) {
      this.form[key] = this[key + 'Has'] ? '#ffffff' : ''
    },
    async getColumnList() {
      const res = await columnList()
      if (res.code === 200) {
        this.typeList = res.data.list
      }
    }
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    this.boxPicker = new iro.ColorPicker('#picker', {
      width: 250,
      color: 'rgb(255, 0, 0)',
      borderWidth: 1,
      borderColor: '#fff',
      layout: [
        {
          component: iro.ui.Box
        },
        {
          component: iro.ui.Slider,
          options: {
            id: 'hue-slider',
            sliderType: 'hue'
          }
        }
      ]
    })
    this.boxPicker.on('color:change', color => {
      // 将当前颜色记录为十六进制字符串
      console.log(color.hexString)
      this.form[this.colorKey] = color.hexString
      this.$forceUpdate()
    })
    // Your mounted hook logic here
    this.getColumnList()
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .every {
      width: 100%;
      // display: flex;
      > span {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        display: flex;
        // width: 100px;
        padding-top: 6px;
      }
      .content {
        width: calc(100% - 100px);
        display: flex;
        margin-top: 15px;
        color: red;
        .radioGroup.ant-radio-group{
          .ant-radio-wrapper{
            padding: 0 5px;
          }
        }
        .preview {
          width: 100%;
          height: 75px;
          border: 9px solid #f3f4f5;
          background: #fff;
          border-radius: 4px;
          padding: 0 26px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > img {
            height: 34px;
            border-radius: 8px;
          }
          .user {
            display: flex;
            align-items: center;
            img {
              width: 14px;
              margin-right: 3px;
            }
          }
        }
        .previewNavigation{
          justify-content: center;
          align-items: center;
          .tag{
            width: 15%;
            font-weight: 400;
            font-size: 18px;
            color: #000000;
            line-height: 1;
            text-align: left;
            font-style: normal;
            position: relative;
            text-align: center;
          }
          .tagSelect{
            color: #F27529;
            &::after{
              content: '';
              width: 23px;
              height: 3px;
              background: #F27529;
              position: absolute;
              bottom: -18px;
              left: 50%;
              margin-left: -11px;
            }
          }
        }
        .colorSelect {
          width: 62px;
          height: 35px;
          background: #fcfcfc;
          border-radius: 6px;
          border: 1px solid #e8ecf0;
          padding-right: 20px;
          box-sizing: border-box;
          position: relative;
          margin-left: 10px;
          overflow: hidden;
          > div {
            width: 100%;
            height: 100%;
            background: #fff;
            border-radius: 0 5px 5px 0;
          }
          img {
            position: absolute;
            top: 14px;
            right: 6px;
            width: 11px;
          }
        }
        .colorSelectBig {
          min-width: 106px;
          display: flex;
          align-items: center;
          > span{
            color: #fff;
            font-size: 12px;
            cursor: pointer;
            background-color: #AFAFAF;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            width: 40px;
            padding: 0 2px;
            line-height: 1.2;
            height: 100%;
          }
        }
        .colorSelectPicker {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
      }
    }
    .must {
      position: relative;
      &::before {
        position: absolute;
        top: 8px;
        left: -5px;
        content: '*';
        color: #ff4d4f;
        margin-left: 5px;
        width: 8px;
      }
      > span {
        // width: 92px;
        padding-left: 15px;
      }
    }
  }
}
</style>
